var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#B3B3B3",
    transform: "translate(6.75 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.585 0h3.169a1 1 0 0 1 1 1v.723h-5.17V1a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.338,
    height: 1.723,
    y: 1.723,
    rx: 0.862
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.862 3.446h8.615v8.477a1 1 0 0 1-1 1H1.862a1 1 0 0 1-1-1V3.446z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6.75 5.169V11.2M3.75 5.169V11.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDelete);
export default __webpack_public_path__ + "static/media/small_delete.90cfe87d15df14a8fd395b3b7b45871f.svg";
export { ForwardRef as ReactComponent };